import React from "react";
import './index.scss';

interface IProps {
    isEnterprise: boolean;
    className?: string;
    isCustomTrophy?: boolean;
    customTrophy?: JSX.Element | string;
}
const TrophyInfo = (props: IProps) => {
    const { isEnterprise, isCustomTrophy = false, customTrophy, className = '' } = props;
    const cls = isEnterprise ? 'trophy-enterprise' : 'trophy-umu';
    const renderContent = () => {
        return !isCustomTrophy ? <div className={`trophy-icon ${cls}`}></div> : (customTrophy || <></>)
    }
    return (
        <div className={`trophy-info ${className}`}>
            {renderContent()}
        </div>
    );
}

export {
    TrophyInfo
}
